// 收件人姓名识别优化：
// 1、先匹配姓名前面可能有 收件人、收货人、姓名、联系人，也可能没有
// 2、再匹配可能是汉字、英文、中英、数字混合
//   2.1、不能全部为数字
// 3、收件人姓名不能有空格
// 4、收件人姓名最长8个字符
// 5、必须在一段没有空格的字符串中去匹配


// 省
// const province = ['广东', '北京', '浙江', '福建', '湖北', '上海', '江苏', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '安徽', '江西', '山东', '河南', '湖南', '广西', '海南', '重庆', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '台湾', '香港', '澳门'];
const province = [
  { name: '广东', children: [] },
  { name: '北京', children: [] },
  { name: '浙江', children: [] },
  { name: '福建', children: [] },
  { name: '湖北', children: [] },
  { name: '上海', children: [] },
  { name: '江苏', children: [] },
  { name: '天津', children: [] },
  { name: '河北', children: [] },
  { name: '山西', children: [] },
  { name: '内蒙古', children: [] },
  { name: '辽宁', children: [] },
  { name: '吉林', children: [] },
  { name: '黑龙江', children: [] },
  { name: '安徽', children: [] },
  { name: '江西', children: [] },
  { name: '山东', children: [] },
  { name: '河南', children: [] },
  { name: '湖南', children: [] },
  { name: '广西', children: [] },
  { name: '海南', children: [] },
  { name: '重庆', children: [] },
  { name: '四川', children: [] },
  { name: '贵州', children: [] },
  { name: '云南', children: [] },
  { name: '西藏', children: [] },
  { name: '陕西', children: [] },
  { name: '甘肃', children: [] },
  { name: '青海', children: [] },
  { name: '宁夏', children: [] },
  { name: '新疆', children: [] },
  { name: '台湾', children: [] },
  { name: '香港', children: [] },
  { name: '澳门', children: [] },
];
// 直辖市
const city = ['北京', '上海', '天津', '重庆'];
// 姓氏
const familyName = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '楮', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闽', '席', '季', '麻', '强', '贾', '路', '娄', '危', '江', '童', '颜', '郭', '梅', '盛', '林', '刁', '锺', '徐', '丘', '骆', '高', '夏', '蔡', '田', '樊', '胡', '凌', '霍', '虞', '万', '支', '柯', '昝', '管', '卢', '莫', '经', '房', '裘', '缪', '干', '解', '应', '宗', '丁', '宣', '贲', '邓', '郁', '单', '杭', '洪', '包', '诸', '左', '石', '崔', '吉', '钮', '龚', '程', '嵇', '邢', '滑', '裴', '陆', '荣', '翁', '荀', '羊', '於', '惠', '甄', '麹', '家', '封', '芮', '羿', '储', '靳', '汲', '邴', '糜', '松', '井', '段', '富', '巫', '乌', '焦', '巴', '弓', '牧', '隗', '山', '谷', '车', '侯', '宓', '蓬', '全', '郗', '班', '仰', '秋', '仲', '伊', '宫', '宁', '仇', '栾', '暴', '甘', '斜', '厉', '戎', '祖', '武', '符', '刘', '景', '詹', '束', '龙', '叶', '幸', '司', '韶', '郜', '黎', '蓟', '薄', '印', '宿', '白', '怀', '蒲', '邰', '从', '鄂', '索', '咸', '籍', '赖', '卓', '蔺', '屠', '蒙', '池', '乔', '阴', '郁', '胥', '能', '苍', '双', '闻', '莘', '党', '翟', '谭', '贡', '劳', '逄', '姬', '申', '扶', '堵', '冉', '宰', '郦', '雍', '郤', '璩', '桑', '桂', '濮', '牛', '寿', '通', '边', '扈', '燕', '冀', '郏', '浦', '尚', '农', '温', '别', '庄', '晏', '柴', '瞿', '阎', '充', '慕', '连', '茹', '习', '宦', '艾', '鱼', '容', '向', '古', '易', '慎', '戈', '廖', '庾', '终', '暨', '居', '衡', '步', '都', '耿', '满', '弘', '匡', '国', '文', '寇', '广', '禄', '阙', '东', '欧', '殳', '沃', '利', '蔚', '越', '夔', '隆', '师', '巩', '厍', '聂', '晁', '勾', '敖', '融', '冷', '訾', '辛', '阚', '那', '简', '饶', '空', '曾', '毋', '沙', '乜', '养', '鞠', '须', '丰', '巢', '关', '蒯', '相', '查', '后', '荆', '红', '游', '竺', '权', '逑', '盖', '益', '桓', '公', '万俟', '司马', '上官', '欧阳', '夏侯', '诸葛', '闻人', '东方', '赫连', '皇甫', '尉迟', '公羊', '澹台', '公冶', '宗政', '濮阳', '淳于', '单于', '太叔', '申屠', '公孙', '仲孙', '轩辕', '令狐', '锺离', '宇文', '长孙', '慕容', '鲜于', '闾丘', '司徒', '司空', '丌官', '司寇', '仉', '督', '子车', '颛孙', '端木', '巫马', '公西', '漆雕', '乐正', '壤驷', '公良', '拓拔', '夹谷', '宰父', '谷梁', '晋', '楚', '阎', '法', '汝', '鄢', '涂', '钦', '段干', '百里', '东郭', '南门', '呼延', '归', '海', '羊舌', '微生', '岳', '帅', '缑', '亢', '况', '后', '有', '琴', '梁丘', '左丘', '东门', '西门', '商', '牟', '佘', '佴', '伯', '赏', '南宫', '墨', '哈', '谯', '笪', '年', '爱', '阳', '佟', '第五', '言', '福'];

// 匹配姓名
function parseName(content, contents) {
  const namePattern = /(?:收件人|收货人|姓名|联系人)[:：]?\s*([\u4e00-\u9fa5A-Za-z0-9·-]{1,10})/;
  const nameMatch = content.match(namePattern);
  let name = nameMatch ? nameMatch[1] : null;
  let maxLength = 5;

  const nameCall = ['先生', '小姐', '同志', '哥哥', '姐姐', '妹妹', '弟弟', '妈妈', '爸爸', '爷爷', '奶奶', '姑姑', '舅舅'];

  if (!name) {
    // 1、先匹配关键字
    name = contents.find(item => nameCall.find(n => ~item.indexOf(n)));
    // 2、匹配姓氏
    if (!name) {
      name = contents.find(item => familyName.includes(item.slice(0, 1)) && item.length <= maxLength);
    }

    const filters = ['街道', '乡镇', '镇', '乡'];
    let filterContents = contents.filter(item => !(~filters.findIndex(n => ~item.indexOf(n))));

    // 3、匹配中英、数字混合，或全是汉字、英文，不能全部为数字
    if (!name) {
      const isChineseOrEnglish = /^[\u4e00-\u9fa5A-Za-z]+$/;
      const isMixed = /^[\u4e00-\u9fa5A-Za-z0-9]+$/;
      const isAllDigits = /^\d+$/;
      name = filterContents.find(item => {
        // 判断item是汉字、英文、中英、数字混合，或全是汉字、英文，不能全部为数字
        if ((isChineseOrEnglish.test(item) || (isMixed.test(item) && !isAllDigits.test(item))) && item.length <= maxLength) {
          return item;
        }
      });
    }
  }
  return name;
}

// 匹配手机号
function parsePhone(content) {
  const phonePattern = /(?:\+?86)?1[2-9]\d{9}/;
  const phoneMatch = content.match(phonePattern);
  const phone = phoneMatch ? phoneMatch[0] : null;
  return phone;
}

const cityObj = {};
const districtObj = {};
let districtList = [];
let areaList = [];
// 用来记录匹配到的关键字
let regAreaKey = {
  province: '',
  city: '',
  district: ''
};
// 设置regAreaKey 省、市、区
function setRegAreaKey(p, c, d) {
  regAreaKey.province = p;
  regAreaKey.city = c;
  regAreaKey.district = d;
}

function formatArea(list, init) {
  if (areaList.length) {
    return true;
  }
  areaList = list;
  areaList.forEach(province => {
    if (province.children) {
      province.children.forEach(city => {
        // if (city.name !== '其他') {
        //   if (!cityObj[city.name]) {
        //     cityObj[city.name] = [];
        //   }
        //   cityObj[city.name].push({
        //     p: province.name,
        //     c: city.name,
        //     d: city.children || [],
        //     pId: province.id,
        //     cId: city.id
        //   });
        // }
        if (city.children) {
          city.children.forEach(area => {
            if (area !== '其他') {
              districtList.push({
                p: province.name,
                c: city.name,
                d: area.name,
                pId: province.id,
                cId: city.id,
                dId: area.id
              });
              // if (!districtObj[area.name]) {
              //   districtObj[area.name] = [];
              // }
              // districtObj[area.name] = {
              //   p: province.name,
              //   c: city.name,
              //   d: area.name,
              //   pId: province.id,
              //   cId: city.id,
              //   dId: area.id
              // }
            }
          });
        }
      });
    }
  });
}

// 地区解析
function parseArea(content, cityData) {
  let areaKey = null;
  let p = null;  // 省
  let c = null;  // 市
  let d = null;  // 区、县

  const area = filterArea(content, province);
  areaKey = area?.areaKey;

  p = areaKey ? getArea(areaKey, cityData) : null;
  if (p && p.children) {
    // 匹配市，从前完后匹配
    c = filterArea(content, p.children);

  }

  if (c  && c.areaValue.children) {
    // 匹配区
    d = filterArea(content, c.areaValue.children);
  }

  if (areaKey && c && d) {
    setRegAreaKey(areaKey, c.areaKey, d.areaKey);
  } else {
    setRegAreaKey(null, null, null);
  }

  if (!p || !c || !d) {
    // 从后往前匹配
    const district = filterAreaBack(content, districtList);
    if (district) {
      p = district.province;
      c = district.city;
      d = district.district;
    }
  }

  return {
    province: {
      id: p?.id,
      name: p?.name
    },
    city: {
      id: c?.id || c?.areaValue?.id,
      name: c?.name || c?.areaValue?.name
    },
    district: {
      id: d?.id || d?.areaValue?.id,
      name: d?.name || d?.areaValue?.name
    }
  };
}

// 获取省、市、区
function getArea(areaKey, cityData) {
  const area = cityData.find(item => item.name.startsWith(areaKey));
  return area;
}
// 从前往后 筛选出省、市、区
function filterArea(str, area) {
  let areaKey = null;
  let areaValue = null;

  for (let j = 0; j < area.length; j++) {
    if (str.includes(area[j].name)) {
      areaKey = area[j].name;
      areaValue = area[j];
      break;
    }
  }

  if (!areaKey) {
    return null;
  }

  return {
    areaKey,
    areaValue,
  };
}

// 从后往前 筛选出省、市、区
function filterAreaBack(str, area) {
  let areaKey = null;
  let provinceKey = null;
  let cityKey = null;
  let result = [];
  setRegAreaKey(null, null, null);

  for (let j = 0; j < area.length; j++) {
    if (str.includes(area[j].d)) {
      areaKey = area[j].d;
      result.push(area[j]);
    }
  }

  let resultObj = null;
  result.forEach(item => {
    const { p, c } = item;
    // 过滤p中的provinceKey
    let p1 = p.replace(/特别行政区|古自治区|维吾尔自治区|壮族自治区|回族自治区|自治区|省省直辖|省|市/, '');
    // 过滤c中的cityKey
    let c1 = c.replace(/布依族苗族自治州|苗族侗族自治州|自治州|州|市|县/, '');
    if (str.includes(p1) || str.includes(c1)) {
      resultObj = item;
      provinceKey = p1;
      cityKey = c1;
    }
  });

  if (!areaKey) {
    return null;
  }

  if (!resultObj) {
    resultObj = result[0];
  }

  setRegAreaKey(provinceKey, cityKey, resultObj.d);

  return {
    province: {
      id: resultObj.pId,
      name: resultObj.p
    },
    city: {
      id: resultObj.cId,
      name: resultObj.c
    },
    district: {
      id: resultObj.dId,
      name: resultObj.d
    }
  };
}

// 解析详细地址
function parseDetailAddress(content, contents, name) {
  const addrPattern = /(?:地址|收货地址|详细地址|住址|详细住址)[:：]?\s*(.+)/;
  let addr = null;
  let { district, city, province } = regAreaKey;

  try {
    // 1、直接匹配关键字后面的地址
    contents.forEach(item => {
      const addrMatch = item.match(addrPattern);
      !addr && (addr = addrMatch ? addrMatch[1] : null);
    });

    // 2、匹配县后面的地址
    if (!addr) {
      contents.forEach(item => {
        // 2、匹配县后面的地址
        const index = item.indexOf(district);
        // 且index 的后面还有值
        if (district && index !== -1 && item.slice(index + district.length).length > 0) {
          addr = item.slice(index + district.length);
        }
      });
    }

    // 3、匹配省后面的地址
    // if (!addr) {
    //   contents.forEach((item, i) => {
    //     // 3、匹配省后面的地址
    //     const index = item.indexOf(district);
    //     if (district && index !== -1) {
    //       const nextItem = contents[i + 1];
    //       // 如果下一个元素长度大于2，且不全都是数字, 且不包含name
    //       if (nextItem && nextItem.length > 2 && !/^\d+$/.test(nextItem)) {
    //         addr = nextItem;
    //       }
    //     }
    //   });
    // }

    // 4、获取剩余地址中最长的
    const filterContents = contents.filter(item => {
      if (!/^\d+$/.test(item) && !item.includes(city) && !item.includes(province)) {
        return item;
      }
    });
    if (!addr) {
      addr = filterContents.join('');
    }
  } catch (error) {
  }

  return addr;
}

// 解析地址
function parseAddress(adr, cityData) {
  let name = null;
  let phone = null;
  let p = null;
  let c = null;
  let d = null;
  let detailAddress = null;
  try {
    formatArea(cityData);
    const formatAdr = adr.replace(/\s+/g, ' ').replace(/[:：]\s+/g, '：').replace(/[，,；;]/g, ' ');
    const adrArray = formatAdr.split(' ');

    name = parseName(formatAdr, adrArray);
    phone = parsePhone(formatAdr);

    // 解析省市区
    const { province, city, district } = parseArea(formatAdr, cityData);
    // 解析详细地址
    const newAdrArray = adrArray.filter(item => !item.includes(name));
    detailAddress = parseDetailAddress(formatAdr, newAdrArray);

    p = province;
    c = city;
    d = district;
  } catch (error) {
  }

  return {
    name,
    phone,
    province: p,
    city: c,
    district: d,
    detailAddress
  };
}

export {
  parseName,
  parseArea,
  parsePhone,
  parseAddress,
};